export const LIST_ITEM_HEIGHT = 34;
export const INCREASED_LIST_ITEM_HEIGHT = LIST_ITEM_HEIGHT + 12;
export const REGULAR_DIALOG_HEIGHT = 510;
export const INCREASED_DIALOG_HEIGHT = 586;
